<template>
  <div class="prescription">
    <div v-if="false" class="header-tab">
      <div v-for="(item, index) in tabList" :key="item.index">
        <el-card
          class="prescription_title_card"
          shadow="hover"
          v-if="item.show"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.introduce"
            placement="bottom"
          >
            <div class="prescription_title_content">
              <div class="prescription_title_img">
                <img :src="item.icon" alt />
              </div>
              <div class="text">
                <el-tag class="title" :type="setType(index)">{{
                  item.title
                }}</el-tag>
                <p class="num">{{ item.number || 0 }}</p>
              </div>
            </div>
          </el-tooltip>
        </el-card>
      </div>
    </div>
    <div class="bd">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <div class="searchList mainItem">
            <el-select
              v-model="status"
              placeholder="请选择"
              @change="optChange"
            >
              <el-option
                v-for="item in options"
                :key="item.status"
                :label="item.label"
                :value="item.status"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="block searchTime mainItem">
            <el-date-picker
              v-model="time"
              type="daterange"
              align="center"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              @change="timeChange"
            ></el-date-picker>
          </div> -->
        </div>
        <div class="text lis-bd" style="min-height: 300px">
          <div v-if="listData.length != 0" class="listWarpper">
            <el-card
              shadow="hover"
              v-for="item in listData"
              :key="item.index"
              style="margin-bottom: 10px"
            >
              <div class="content">
                <div class="c_img">
                  <img :src="item.memberAvatarText || defalutAvatar" alt />
                </div>
                <div class="content-right">
                  <div class="text centerBox">
                    <p>姓名：{{ item.patient.patientName }}</p>
                    <p>年龄：{{ item.patient.patientAge }}</p>
                    <!-- <p>科室：{{ item.department_name }}</p> -->
                    <p>
                      进度状态：
                      <!-- 状态 
                      0未审核 
                      3 一级药师审核驳回 
                      5 一级药师未签字(通过处方)
                      6一级药师已审核(复核药师待审核)
                      7 复核药师未签字(驳回处方)
                      8 复核药师驳回
                      9 复核药师未签字
                      10 复核药师审核通过【报告待生成】
                      100报告生成-->
                      <!-- 已出报告  -->
                      <el-tag effect="plain">{{
                        PRESCRIPTION_STATUS[item.recipe.status]
                      }}</el-tag>
                    </p>
                  </div>
                  <div class="text right_box">
                    <!-- 签名 0待签名 1已签名 2签名失败 -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="该处方尚未签名,点击即可发起签名"
                      placement="top"
                    >
                      <el-button
                        v-if="
                          item.recipe.status == 11805 ||
                          item.recipe.status == 11804
                        "
                        type="primary"
                        class="signature"
                        @click="signature(item)"
                        >签名
                      </el-button>
                    </el-tooltip>
                    <p
                      class="c_btn"
                      v-if="item.recipe.status == 11806"
                      @click="getPdf(item)"
                    >
                      生成报告
                    </p>
                    <p
                      class="c_btn"
                      v-if="item.recipe.status === 11807"
                      @click="downloadPdf(item)"
                    >
                      下载
                    </p>
                    <p class="c_btn" @click="reportDetail(item.recipe)">
                      查看详情
                    </p>
                    <p class="c_time">{{ item.recipe.createTime }}</p>
                  </div>
                </div>
              </div>
            </el-card>
            <div class="page">
              <el-pagination
                v-if="listData != ''"
                @current-change="currentPageChange"
                :page-size="pageList.pageSize"
                :current-page="pageList.currentPage"
                layout="total, prev, pager, next"
                :total="pageList.totalCount"
              ></el-pagination>
            </div>
          </div>
          <div v-else class="empty">
            <emptyData />
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const defalutAvatar = require("@/assets/images/defaultIcon.jpg");
import { PRESCRIPTION_STATUS } from "@/utils/constants.js";

import {
  getOrderList,
  prescriptionTotal,
  // prescription,
  // prescriptionPdf,
} from "@/api";
import {
  prescriptionSign,
  prescriptionSignReview,
  prescriptionPdf,
  downloadPrescriptionPdf,
} from "@/api/doctor";
import pdf from "vue-pdf";
import util from "@/utils";
import emptyData from "@/components/common/emptyData.vue";
import config from "@/config/config.js";

export default {
  name: "",
  components: { pdf, emptyData },
  props: {},
  data() {
    const isUserType = util.getStore("userType");
    return {
      PRESCRIPTION_STATUS,
      userType: util.getStore("userType"),
      user: {},
      listData: [],
      pageList: { pageSize: 5, currentPage: 1, totalCount: 0 },
      defalutAvatar: config.defaultUserPatientsIcon,
      isPdfShow: false,
      pdfUrl: "",
      tabName: "",
      options: [
        {
          status: "",
          label: "全部",
        },
        // {
        //   status: "2",
        //   label: "一级药师待审核",
        // },
        // {
        //   status: "3",
        //   label: "一级药师审核驳回",
        // },
        // {
        //   status: "6",
        //   label: "复核药师待审核【一级药师已审核】",
        // },
        // {
        //   status: "8",
        //   label: "复核药师驳回",
        // },
        {
          status: "10",
          label: "审核通过【报告待生成】",
        },
        {
          status: "100",
          label: "报告生成",
        },
      ],
      status: "",
      time: [],
      tabList: [
        {
          icon: require("../../../assets/images/prescription1.png"),
          title: "合计处方",
          introduce: "当前所有已经审核过的处方",
          number: "",
          show: true,
        },
        {
          icon: require("../../../assets/images/prescription2.png"),
          title: "待审核处方",
          introduce: "当前已经提交审核并且待审的处方",
          number: "",
          show: true,
        },
        {
          icon: require("../../../assets/images/prescription2.png"),
          title: "审核中",
          introduce: "当前用户已经提交并且在审核中的处方合计",
          number: "",
          show: isUserType == 1 ? true : false,
        },
        {
          icon: require("../../../assets/images/prescription2.png"),
          title: "待签处方",
          introduce: "当前审核通过或者拒绝的处方待签字合计",
          number: "",
          show: true,
        },
        {
          icon: require("../../../assets/images/prescription3.png"),
          title: "不合格处方",
          introduce: "当前已经提交并且拒绝的处方",
          number: "",
          show: isUserType == 1 ? true : false,
        },
        {
          icon: require("../../../assets/images/prescription4.png"),
          title: "合格处方",
          introduce: "截止此时已经审核通过的处方",
          number: "",
          show: true,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
    };
  },
  mounted() {
    this.status = this.$route.query.status || "";
    this.getReportList();
    this.indexPrescriptionTotal();
  },
  methods: {
    // 下载报告
    async downloadPdf(item) {
      console.log(item);
      const params = {
        recipeId: item.recipe.id,
      };
      const res = await downloadPrescriptionPdf(params);

      // 创建隐藏<a>标签进行下载
      let filename = item.patient.patientName;
      var tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = res.data;
      tempLink.setAttribute("download", filename);
      tempLink.setAttribute("target", "_blank");
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      // let blob = new Blob([res.data], {
      //   type: "application/pdf;charset=utf-8",
      // });
      // let filename = item.patient.patientName;
      // if (typeof window.navigator.msSaveBlob !== "undefined") {
      //   window.navigator.msSaveBlob(blob, filename);
      // } else {
      //   var blobURL = window.URL.createObjectURL(blob);
      //   // 创建隐藏<a>标签进行下载
      //   var tempLink = document.createElement("a");
      //   tempLink.style.display = "none";
      //   tempLink.href = blobURL;
      //   tempLink.setAttribute("download", filename);
      //   if (typeof tempLink.download === "undefined") {
      //     tempLink.setAttribute("target", "_blank");
      //   }
      //   document.body.appendChild(tempLink);
      //   tempLink.click();
      //   document.body.removeChild(tempLink);
      //   window.URL.revokeObjectURL(blobURL);
      // }
    },
    //标签类型设置
    setType(index) {
      switch (index) {
        case 0:
          return "primary";
          break;
        case 1:
          return "danger";
          break;
        case 2:
          return "warning";
          break;
        case 3:
          return "success";
          break;
      }
    },
    async indexPrescriptionTotal() {
      try {
        const params = {
          pharmacistId: util.getStore("user_id"),
          userType: util.getStore("userType"),
        };
        let res = await prescriptionTotal(params);
        if (res.success) {
          // totalPR);//合计处方
          // totalWaitAuditDoing);//审核中处方
          // totalWaitAudit);//待审核处方
          // unQualified);//不合格处方
          // totalWaitSign);//待签处方
          // qualified);//合格处方
          this.tabList[0].number = res.result.totalPR;
          this.tabList[1].number = res.result.totalWaitAudit;
          this.tabList[2].number = res.result.totalWaitAuditDoing;
          this.tabList[3].number = res.result.totalWaitSign;
          this.tabList[4].number = res.result.unQualified;
          this.tabList[5].number = res.result.qualified;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /*
     *签名
     */
    async signature(item) {
      try {
        const params = {
          recipeId: item.recipe.id,
        };
        let res;
        if (item.recipe.status == "11805") { // 处方复核签字
          res = await prescriptionSignReview(params);
        } else {
          res = await prescriptionSign(params);
        }
        if (res.code == 1) {
          // this.elementTips("success", '已提交签名任务至信手书，请在信手书完成下一步签名操作');
          window.location.href = res.data;
          this.getReportList();
        } else {
          this.elementTips("warning", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     *生成报告
     */
    async getPdf(item) {
      try {
        let data = {
          recipeId: item.recipe.id,
        };
        let res = await prescriptionPdf(data);
        if (res.code == 1) {
          this.elementTips("success", res.message);
          this.getReportList();
        } else {
          this.elementTips("warning", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 选择状态
     */
    optChange() {
      console.log("status", this.status);
      this.getReportList();
    },
    //时间搜索
    timeChange() {
      console.log("time", this.time);
      this.getReportList();
    },
    currentPageChange(val) {
      this.pageList.currentPage = val;
      this.getReportList();
    },
    /**
     * 点击预览详情
     */
    reportDetail(item) {
      console.log("item:", item);
      let query = {
        id: item.id,
        orderNo: item.orderNo,
      };
      this.$router.push({
        path: "/index/user/auditPrescription/prescriptionDetails",
        query,
      });
    },
    getReportList() {
      const that = this;
      console.log("获取列表了", that.time);
      let startTime;
      let endTime;
      if (that.time) {
        startTime = that.time[0];
        endTime = that.time[1];
      }
      let data = {
        startDate: startTime,
        endDate: endTime,
        currentPage: this.pageList.currentPage,
        pageSize: this.pageList.pageSize,
      };
      getOrderList(data).then((res) => {
        if (res.code == 1) {
          this.listData = res.data.dataList;
          this.pageList.totalCount = Number(res.data.totalCount);
        }
      });
    },
    handleClose(done) {
      console.log("关闭了");
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.prescription {
  width: 80%;
  margin: 0 auto;
}
.listWarpper {
  margin-top: 10px;
}
.content {
  display: flex;
  padding: 20px;
  .c_img {
    // flex: 0 0 10%;
    width: 100px;
    height: 100px;
    text-align: center;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100px;
    }
  }
  .content-right {
    flex: 1;
    display: flex;
    .text {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .signature {
      align-content: center;
      width: 80px;
      margin: 0 auto;
    }
    .centerBox {
      flex: 0 0 65%;
      margin-left: 15px;
    }
    .right_box {
      flex: 0 0 25%;
      text-align: center;
      .c_btn {
        // color: #409eff;
        color: #fc701a;
        cursor: pointer;
      }
      .c_time {
        color: rgb(167, 157, 157);
      }
    }
  }
}
.header-tab {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  .prescription_title_card {
    width: 180px;
    text-align: center;
  }
}
// @media (min-height: 1000px) {
//   .prescription_title_card {
//     width: 250px;
//     text-align: center;
//   }
// }
.bd {
  margin: 20px 0;
  .mainItem {
    float: left;
  }
  .page {
    text-align: center;
  }
}
.mainItem:nth-child(2) {
  margin-left: 20px;
}
.pdf span {
  display: block !important;
}
.prescription_card {
  //   height: 130px;
  margin-top: 20px;
}
.prescription_card_p_title {
  font-weight: 700;
  margin-bottom: 10px;
}

.prescription_title_card {
  background-color: #f6f7fb;
}
.prescription_title_content {
  padding: 15px 0 0 0;
  .text {
    .title {
      font-size: 22px;
      margin-top: 10px;
    }
    .num {
      font-size: 18px;
      margin-top: 10px;
      color: rgba(000, 00, 0, 0.8);
    }
  }
}

.prescription_title_img img {
  width: 60px;
}
.prescription .empty {
  width: 10%;
  margin: 0 auto;
  margin-top: 10%;
}
.prescription .right_box .el-tag {
  margin: 0 auto;
  width: 30%;
}
</style>
